import React from "react";
import { roles } from "shared/constants/Constants.js";

const controlTowerRoutes = {
  dashboard: [
    {
      path: "dashboard",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-dashboard" */
          "../../feature/control-tower/dashboard/Dashboard.js"
        ),
      authorized: [roles.ADMIN],
    },
    {
      path: "margin",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-margin" */
          "../../feature/control-tower/Margin/Margin.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Margin",
    },
    {
      path: "revenue",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-revenue" */
          "../../feature/control-tower/revenue/Revenue.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Revenue",
    },
    {
      path: "cost",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-cost" */
          "../../feature/control-tower/cost/Cost.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Cost",
    },
    {
      path: "direct-cost",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-direct-cost" */
          "../../feature/control-tower/directCost/DirectCost.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Direct Cost",
    },
    {
      path: "indirect-cost",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-indirect-cost" */
          "../../feature/control-tower/indirectCost/IndirectCost.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Indirect Cost",
    },

    {
      path: "collections",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-collections" */
          "../../feature/control-tower/collection/Collections.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Collections",
    },

    {
      path: "bad-debt",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-bad-debt" */
          "../../feature/control-tower/badDebt/BadDebt.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Bad Debt",
    },
    {
      path: "asset-utilization",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-asset-utilization" */
          "../../feature/control-tower/assetUtilization/AssetUtilization.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Asset Util",
    },
    {
      path: "closure-rate",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-closure-rate" */
          "../../feature/control-tower/closureRate/ClosureRate.js"
        ),
      authorized: [],
    },
    {
      path: "driver-onboarding",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-driver-onboarding" */
          "../../feature/control-tower/FunnelDriverOnboarding.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Driver Onboarding",
    },
    {
      path: "driver-avg-life",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-driver-avg-life" */
          "../../feature/control-tower/FunnelDriverAvgLife.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Driver Avg Life",
    },
    {
      path: "driver-avg-temp-drop",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "control-tower-driver-avg-temp-drop" */
          "../../feature/control-tower/FunnelDriverAvgTempDrop.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "controlTower",
      sidebarLabel: "Avg Temp Drop",
    },
  ],
  standalone: [],
};

export default controlTowerRoutes;
